import { Magic } from "magic-sdk";
import { BaseMagiclinkService } from "./base-magiclink.service";

export class MagiclinkService extends BaseMagiclinkService {
  constructor() {
    super();
  }

  logout = async () => {
    await this.magic!.user.logout();
  };

  handleLoginWithEmail = async (email: string) => {
    await this.magic!.auth.loginWithMagicLink({
      email,
      showUI: true,
      redirectURI: new URL(
        `/app/auth/login/redirect/${email}`,
        window.location.origin
      ).href,
    });
  };

  // Alternative: If magic link is not working, use OTP flow
  handleLoginWithEmailOTP = async (email: string) => {
    const handle = this.magic!.auth.loginWithEmailOTP({
      email,
      showUI: true
    });

    return new Promise((resolve, reject) => {
      handle
        .on('done', (result) => {
          resolve(result);
        })
        .on('error', (reason) => {
          alert(reason);
          reject(reason);
        })
        .on('verify-email-otp', () => {
          alert('Email sent, now prompt for OTP');
        })
        .on('invalid-email-otp', () => {
          alert('Invalid code. Please try again.');
        });
    });
  };

  handleUserRegisterWithEmail = async (
    email: string,
    callback: (token: string) => void
  ) => {
    await this.magic!.auth.loginWithMagicLink({
      email,
    }).addListener("done", (token: string | null) => {
      callback(token);
    });
  };

  getUser = async () => {
    return this.magic?.user?.getMetadata();
  };

  // Do not use unless you have to
  // Use Redux !!token.accessToken instead
  isAuthenticated = async () => {
    return new Promise<boolean>((resolve) => {
      this.magic?.user?.isLoggedIn().then((loggedIn) => {
        resolve(loggedIn);
      });
    });
  };

  getIdToken = async () => {
    return new Promise<string>((resolve) => {
      this.magic?.user?.getIdToken().then((token) => {
        resolve(token);
      });
    });
  };

  userEmail = async () => {
    return new Promise<string | null>((resolve) => {
      this.magic?.user
        ?.getMetadata()
        .then((metaData) => {
          resolve(metaData?.email);
        })
        .catch(async () => {
          await this.logout();
          resolve("");
        });
    });
  };
}

export const magiclinkService = new MagiclinkService();
